import { DESELECT_MODEL } from "./types";

const deselectModel = () => async (dispatch) => {
    dispatch({ type: DESELECT_MODEL });
};

export default deselectModel;
